import React, { useCallback, useState } from "react";
import {
  GestureResponderEvent,
  Linking,
  Platform,
  TextProps,
} from "react-native";

import { ArrowRightIcon, RedirectIcon } from "../../icons_v2/general";
import { HStack, Text } from "./../../primitive";

export type LinkProps = React.PropsWithChildren<
  TextProps & {
    href?: string;
    iconType?: "internal" | "external";
    onPress?: (event: GestureResponderEvent) => void;
    rel?: string;
    target?: string;
    variant?: "mainBaseMedium" | "mainSmallMedium" | "mainTiny";
  }
>;
export const Link = ({
  href,
  children,
  iconType,
  onPress,
  rel,
  target,
  variant = "mainBaseMedium",
}: LinkProps) => {
  const webProps = {
    href,
    hrefAttrs: {
      rel: target === "_blank" ? rel ?? "noopener noreferrer" : rel,
      target,
    },
  };
  const [isPressed, setIsPressed] = useState(false);
  const handlePressIn = useCallback(() => {
    setIsPressed(true);
  }, []);
  const handlePressOut = useCallback(() => {
    setIsPressed(false);
  }, []);
  const restProps = Platform.OS === "web" ? webProps : {};

  return (
    <HStack justifyContent="center" gap={2}>
      <Text
        role="link"
        color={
          isPressed
            ? "button-main-surface-pressed"
            : "button-main-surface-neutral"
        }
        textDecorationLine={"underline"}
        variant={variant}
        onPress={(event) => {
          if (onPress) {
            onPress(event);
          }
          if (Platform.OS !== "web" && !!href) {
            Linking.openURL(href);
          }
        }}
        onPressIn={handlePressIn}
        //@ts-ignore -- necessary to catch mouse as well as touch
        onMouseDown={handlePressIn}
        //@ts-ignore
        onMouseUp={handlePressOut}
        onPressOut={handlePressOut}
        {...restProps}
      >
        {children}
      </Text>
      {!!iconType ? (
        <>
          {iconType === "internal" ? (
            <ArrowRightIcon
              testID="arrow-right-icon"
              color={
                isPressed ? "button-main-surface-pressed" : "text-main-primary"
              }
            />
          ) : null}
          {iconType === "external" ? (
            <RedirectIcon
              testID="redirect-icon"
              color={
                isPressed ? "button-main-surface-pressed" : "text-main-primary"
              }
            />
          ) : null}
        </>
      ) : null}
    </HStack>
  );
};
